module.exports = __webpack_public_path__ + "img/BlinkArt_Sword6_Yellow.7f597165.png";